import { SyntheticEventData } from 'react-dom/test-utils';
import { useChatContext } from 'src/chat/hooks/useChatContext';
import { OrderShefFragment } from 'src/gqlReactTypings.generated.d';
import { ButtonColors, ButtonSizes, PrimaryButton } from 'src/shared/design-system/Buttons';
import styled from 'styled-components';
import Chat from 'web-common/src/shared/design-system/icons/Chat.svg';
import { ScreenWidth, Spacing } from 'web-common/src/shared/styles';

interface IProps {
  shef: OrderShefFragment;
}

const Button = styled(PrimaryButton)`
  position: relative;
  padding: 0 ${Spacing.SINGLE_QUARTER} 0 ${Spacing.SINGLE};

  @media (max-width: ${ScreenWidth.SMALL}) {
    padding: 0 6px 0 12px;
    > span {
      display: none;
    }
  }
`;
export const MessageShefButton: React.FC<IProps> = ({ shef }) => {
  const { openWidget } = useChatContext();

  const handleClick = (e: SyntheticEventData) => {
    openWidget?.(shef);
    e.stopPropagation?.();
  };

  if (!openWidget || shef.celebrityEventType || !shef.shefProfile.allowedToChat) return null;

  return (
    <Button color={ButtonColors.LIGHT_GRAY} size={ButtonSizes.M} onClick={handleClick}>
      <div className='relative justify-start rounded-full border-2 border-eggplant-50 bg-rice'>
        <img src={Chat} alt='Chat' className='flex size-4 justify-end' />
      </div>
      &nbsp; <span>Message</span>
    </Button>
  );
};
